// 卡片型课程
// 与后台数据耦合 属于容器型组件

import style from '@style/course.module.scss'

export default {
  props: ['dataSource'],

  render () {
    const {
      dataSource // from this.props
    } = this

    return (dataSource.imageUrl || dataSource.title) && (
      <div class={style.courseCard} onClick={() => this.$emit('click')}>
        <img class='img-w' src={dataSource.imageUrl} alt={dataSource.title} />
        <div class={style.courseCardContent}>
          <h3 class={style.courseCardTitle}>{dataSource.title}</h3>
          <p class={style.courseCardDesc}>{dataSource.recommendWord}</p>
          <div class={style.courseCardBottom}>
            <span class={style.courseCardBottomPrice}>{dataSource.priceStr && dataSource.priceStr !== '' ? `￥${dataSource.priceStr}` : ''}</span>
            <span class={style.courseCardBottomSeperate} />
            <span class={style.courseCardBottomCount}>{dataSource.subscribeCountStr}</span>
          </div>
        </div>
      </div>
    )
  }
}
